import { dbPromise } from "../index";
import { FilterItem, DisplayItem } from "models/CorpScreening";

// IndexedDBから絞り込みツリーを取得する
export const getFilterTreeFromDB = async (): Promise<FilterItem[] | null> => {
  try {
    const db = await dbPromise;
    const tx = db.transaction("screeningTree", "readonly");
    const store = tx.objectStore("screeningTree");
    const result = await store.get("filterTree");
    await tx.done;
    return result ? result.data : null;
  } catch (error) {
    console.error("Failed to get filter tree from IndexedDB:", error);
    return null;
  }
};

// IndexedDBから表示項目ツリーを取得する
export const getDisplayTreeFromDB = async (): Promise<DisplayItem[] | null> => {
  try {
    const db = await dbPromise;
    const tx = db.transaction("screeningTree", "readonly");
    const store = tx.objectStore("screeningTree");
    const result = await store.get("displayTree");
    await tx.done;
    return result ? result.data : null;
  } catch (error) {
    console.error("Failed to get display tree from IndexedDB:", error);
    return null;
  }
};

// IndexedDBに絞り込みツリーを保存する
export const saveFilterTreeToDB = async (filterTree: FilterItem[]) => {
  try {
    const db = await dbPromise;
    const tx = db.transaction("screeningTree", "readwrite");
    const store = tx.objectStore("screeningTree");
    await store.put({ id: "filterTree", data: filterTree });
    await tx.done;
  } catch (error) {
    console.error("Failed to save filter tree to IndexedDB:", error);
    throw error;
  }
};

// IndexedDBに表示項目ツリーを保存する
export const saveDisplayTreeToDB = async (displayTree: DisplayItem[]) => {
  try {
    const db = await dbPromise;
    const tx = db.transaction("screeningTree", "readwrite");
    const store = tx.objectStore("screeningTree");
    await store.put({ id: "displayTree", data: displayTree });
    await tx.done;
  } catch (error) {
    console.error("Failed to save display tree to IndexedDB:", error);
    throw error;
  }
};
